function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".DOT_svg__st0{fill:#e6007a}");

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  className: "DOT_svg__st0",
  cx: 663,
  cy: 147.9,
  rx: 254.3,
  ry: 147.9
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  className: "DOT_svg__st0",
  cx: 663,
  cy: 1262.3,
  rx: 254.3,
  ry: 147.9
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-60 180.499 426.56)",
  className: "DOT_svg__st0",
  cx: 180.5,
  cy: 426.5,
  rx: 254.3,
  ry: 148
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-60 1145.575 983.768)",
  className: "DOT_svg__st0",
  cx: 1145.6,
  cy: 983.7,
  rx: 254.3,
  ry: 147.9
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 180.45 983.72)",
  className: "DOT_svg__st0",
  cx: 180.5,
  cy: 983.7,
  rx: 148,
  ry: 254.3
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 1145.522 426.601)",
  className: "DOT_svg__st0",
  cx: 1145.6,
  cy: 426.6,
  rx: 147.9,
  ry: 254.3
});

function SvgDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    id: "DOT_svg__Logo",
    x: 0,
    y: 0,
    viewBox: "0 0 1326.1 1410.3",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default __webpack_public_path__ + "a87d5e824cc606a0c2fd52806abd11e6.svg";
export { SvgDot as ReactComponent };